import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { environment } from '../../../../environments/environment';

export enum FeatureToggleAccessLevelsEnum {
  n = 'n', // no access (hidden from user)
  r = 'r', // read-only access
  w = 'w', // full access
  f = 'f', // forbidden (limited access user)
}

const DEFAULT_ACCESS_LEVEL = FeatureToggleAccessLevelsEnum.n;

export const TOGGLES_SCHEMA = Object.freeze({
  ADD_COMPANY: DEFAULT_ACCESS_LEVEL,
  ADD_USERS: DEFAULT_ACCESS_LEVEL,
  ADDRESS_AUTOCOMPLETE: DEFAULT_ACCESS_LEVEL,
  ALL_PAYMENT_REMINDER_OPTIONS_ENABLED: DEFAULT_ACCESS_LEVEL,
  ANDROID: DEFAULT_ACCESS_LEVEL,
  APPOINTMENTS: DEFAULT_ACCESS_LEVEL,
  APPOINTMENTS_FEEDBACK: DEFAULT_ACCESS_LEVEL,
  ATTACHMENT: DEFAULT_ACCESS_LEVEL,
  BARCODE: DEFAULT_ACCESS_LEVEL,
  CALENDAR: DEFAULT_ACCESS_LEVEL,
  CARD_PAYMENTS: DEFAULT_ACCESS_LEVEL,
  CHANGE_CARD_PAYMENTS: DEFAULT_ACCESS_LEVEL,
  CHANGE_PAYPAL_EC: DEFAULT_ACCESS_LEVEL,
  CHARGE_CARD_IN_APP: DEFAULT_ACCESS_LEVEL,
  CLIENT_ACTIVITY: DEFAULT_ACCESS_LEVEL,
  CLIENT_LISTING: DEFAULT_ACCESS_LEVEL,
  CONVERT_ESTIMATE_TO_INVOICE: DEFAULT_ACCESS_LEVEL,
  CREDIT_MEMO: DEFAULT_ACCESS_LEVEL,
  CUSTOM_BRANDING: DEFAULT_ACCESS_LEVEL,
  DEPOSITS_ON_ESTIMATE: DEFAULT_ACCESS_LEVEL,
  DEPOSITS_ON_INVOICE: DEFAULT_ACCESS_LEVEL,
  DEPOSIT_TOGGLE: DEFAULT_ACCESS_LEVEL,
  EDIT_EMAIL: DEFAULT_ACCESS_LEVEL,
  EMAIL_TRACKING: DEFAULT_ACCESS_LEVEL,
  EMAIL_TEMPLATE_EXPERIMENT: DEFAULT_ACCESS_LEVEL,
  ESTIMATE: DEFAULT_ACCESS_LEVEL,
  ESTIMATE_APPROVAL: DEFAULT_ACCESS_LEVEL,
  ESTIMATE_PAYABLE: DEFAULT_ACCESS_LEVEL,
  EXPENSES: DEFAULT_ACCESS_LEVEL,
  EXPORT: DEFAULT_ACCESS_LEVEL,
  FEE_PASS_THROUGH: DEFAULT_ACCESS_LEVEL,
  FEE_TIERING: DEFAULT_ACCESS_LEVEL,
  FILE_ATTACHMENT: DEFAULT_ACCESS_LEVEL,
  FTU_EXPERIMENT: DEFAULT_ACCESS_LEVEL,
  FTU_TASK_LIST: DEFAULT_ACCESS_LEVEL,
  IA_NAV_EXPERIMENT: DEFAULT_ACCESS_LEVEL,
  IA_NAV_ONBOARDING_BANNER: DEFAULT_ACCESS_LEVEL,
  INSTANT_WEBSITE: DEFAULT_ACCESS_LEVEL,
  INVOICE2GO_MONEY: DEFAULT_ACCESS_LEVEL,
  INVOICES: DEFAULT_ACCESS_LEVEL,
  INSIGHTS_HUB: DEFAULT_ACCESS_LEVEL,
  IN_APP_CANCELLATION: DEFAULT_ACCESS_LEVEL,
  IPAD: DEFAULT_ACCESS_LEVEL,
  IPHONE: DEFAULT_ACCESS_LEVEL,
  ITEM_LISTING: DEFAULT_ACCESS_LEVEL,
  JOB: DEFAULT_ACCESS_LEVEL,
  MANAGE_USERS: DEFAULT_ACCESS_LEVEL,
  MAPS: DEFAULT_ACCESS_LEVEL,
  MFA: DEFAULT_ACCESS_LEVEL,
  NO_BRANDING: DEFAULT_ACCESS_LEVEL,
  PAYMENT_RECEIPTS: DEFAULT_ACCESS_LEVEL,
  PAYMENT_RECEIPTS_SETTINGS: DEFAULT_ACCESS_LEVEL,
  PAYMENT_REMINDERS: DEFAULT_ACCESS_LEVEL,
  PAYMENTS_DEFAULT_ON: DEFAULT_ACCESS_LEVEL,
  PAYPAL_EC: DEFAULT_ACCESS_LEVEL,
  POST_PURCHASE_SURVEY: DEFAULT_ACCESS_LEVEL,
  PROFILE_REVIEWS: DEFAULT_ACCESS_LEVEL,
  PROFILE: DEFAULT_ACCESS_LEVEL,
  PURCHASE_ORDER: DEFAULT_ACCESS_LEVEL,
  REFER_A_FRIEND: DEFAULT_ACCESS_LEVEL,
  REFER_A_FRIEND_EMAIL: DEFAULT_ACCESS_LEVEL,
  REPORTS: DEFAULT_ACCESS_LEVEL,
  SAVE_ITEMS: DEFAULT_ACCESS_LEVEL,
  SCHEDULE: DEFAULT_ACCESS_LEVEL,
  SETTINGS: DEFAULT_ACCESS_LEVEL,
  SIGNING: DEFAULT_ACCESS_LEVEL,
  STATEMENT: DEFAULT_ACCESS_LEVEL,
  STRIPE_ACH_DEBIT: DEFAULT_ACCESS_LEVEL,
  TAX_YEAR_FILTER: DEFAULT_ACCESS_LEVEL,
  TIME_TRACKING: DEFAULT_ACCESS_LEVEL,
  TIME_TRACKING_FEEDBACK: DEFAULT_ACCESS_LEVEL,
  TIP: DEFAULT_ACCESS_LEVEL,
  VERIFY_ACCOUNT: DEFAULT_ACCESS_LEVEL,
  EMAIL_RECIPIENTS: DEFAULT_ACCESS_LEVEL,
  EMAIL_HTML: DEFAULT_ACCESS_LEVEL,
  WEBAPP: DEFAULT_ACCESS_LEVEL,
  XERO: DEFAULT_ACCESS_LEVEL,
});

const RECORD = generateSchema(TOGGLES_SCHEMA);
export const KEYS: any = generateKeys(TOGGLES_SCHEMA);

export class Toggles extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  isForbidden(featureKey: string): boolean {
    return environment.features.featureFramework
      ? this.get(featureKey) === FeatureToggleAccessLevelsEnum.f
      : false;
  }

  isNoAccess(featureKey: string): boolean {
    return environment.features.featureFramework
      ? this.get(featureKey) === FeatureToggleAccessLevelsEnum.n
      : false;
  }

  isReadOnlyAccess(featureKey: string): boolean {
    return environment.features.featureFramework
      ? this.get(featureKey) === FeatureToggleAccessLevelsEnum.r
      : false;
  }

  isAllAccess(featureKey: string): boolean {
    return environment.features.featureFramework
      ? this.get(featureKey) === FeatureToggleAccessLevelsEnum.w
      : true;
  }
}
